
// eventually migrate all mapbox javascript into this file to be included only when needed


require("leaflet")
require("mapbox.js")
require("leaflet.smooth_marker_bouncing")
